import { RequestGateway } from "../RequestGateway";
export class WalletRequestGateway extends RequestGateway {
    constructor(requestService) {
        super(requestService);
        this.token = "";
        this.setToken = () => { };
        this.isPromiseCacheForLogin = false;
    }
    setAnonymousToken(token) {
        this.token = token;
        this.requestService.storage.clearToken();
    }
    setLoginToken(token) {
        this.token = token;
        this.requestService.storage.setToken(token);
    }
    getExistingToken() {
        return this.requestService.storage.getToken() || this.token;
    }
    getToken() {
        this.setToken = this.setAnonymousToken;
        if (!this.promiseCache || this.isPromiseCacheForLogin) {
            let ref = this;
            this.promiseCache = new Promise(function (resolve, reject) {
                ref.getAnonymousToken()
                    .then(token => {
                    resolve(token);
                })
                    .catch(err => {
                    ref.recursiveRenew(err, ref.getAnonymousToken.bind(ref), resolve, reject);
                });
            });
            this.isPromiseCacheForLogin = false;
        }
        return this.promiseCache;
    }
    login(params) {
        this.setToken = this.setLoginToken;
        if (!this.promiseCache || !this.isPromiseCacheForLogin) {
            let ref = this;
            this.promiseCache = new Promise(function (resolve, reject) {
                ref.getLoginToken(params)
                    .then(token => {
                    resolve(token);
                })
                    .catch(err => {
                    ref.recursiveRenew(err, ref.getLoginToken.bind(ref, params), resolve, reject);
                });
            });
            this.isPromiseCacheForLogin = true;
        }
        return this.promiseCache;
    }
    clearLoginToken() {
        this.setToken = this.setAnonymousToken;
        return this.getAnonymousToken();
    }
}
//# sourceMappingURL=WalletRequestGateway.js.map